import React, { useState } from "react";
import "../styles/App.css"; // Import global styles
import { SERVER_URL } from "../config";

const CreateAdmin: React.FC = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [passwordHash, setPasswordHash] = useState("");
  const [confirmPasswordHash, setConfirmPasswordHash] = useState("");
  const [loading, setLoading] = useState(false);
  const [jobTitle, setJobTitle] = useState("");
  const [phone, setPhone] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!firstName || !lastName || !email || !passwordHash) {
      alert("All fields are required.");
      return;
    }

    if (passwordHash !== confirmPasswordHash) {
      alert("PasswordHashs do not match!");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${SERVER_URL}/api/auth/admin/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          firstName,
          lastName,
          email,
          jobTitle,
          phone,
          passwordHash,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        alert("Admin registered successfully!");
        setFirstName("");
        setLastName("");
        setEmail("");
        setJobTitle("");
        setPhone("");
        setPasswordHash("");
        setConfirmPasswordHash("");
      } else {
        alert(data.error || "Failed to register admin.");
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while signing up.");
    }
    setLoading(false);
  };

  return (
    <div className="signup-container">
      <h2>Admin Sign Up</h2>
      <form onSubmit={handleSubmit} className="signup-form">
        <div className="form-group">
          <label htmlFor="firstName">First Name</label>
          <input
            type="text"
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="Phone number">Phone number</label>
          <input
            type="phone number"
            id="phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="Job title">Job title</label>
          <input
            type="Job title"
            id="Job title"
            value={jobTitle}
            onChange={(e) => setJobTitle(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="passwordHash">PasswordHash</label>
          <input
            type="password"
            id="passwordHash"
            value={passwordHash}
            onChange={(e) => setPasswordHash(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="confirmPasswordHash">Confirm PasswordHash</label>
          <input
            type="password"
            id="confirmPasswordHash"
            value={confirmPasswordHash}
            onChange={(e) => setConfirmPasswordHash(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="signup-button" disabled={loading}>
          {loading ? "Signing Up..." : "Sign Up"}
        </button>
      </form>
    </div>
  );
};

export default CreateAdmin;
